/**
 * Подключает студию снимков (`ModelThumbStudio`), пока есть что снимать. Ставится рядом с
 * каталогом; студия и three.js грузятся лениво, только когда карточкам понадобились снимки.
 */
import { lazy, Suspense } from "react";
import { useThumbsStore } from "../thumbs";

const ModelThumbStudio = lazy(() => import("./ModelThumbStudio"));

export const ModelThumbsHost = () => {
	const busy = useThumbsStore((s) => s.queue.length > 0);
	return busy ? (
		<Suspense fallback={null}>
			<ModelThumbStudio />
		</Suspense>
	) : null;
};
